import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 13 13"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#a)" }, [
      _createElementVNode("path", {
        fill: "currentColor",
        d: "M10.593 10.292a1.3 1.3 0 0 1-.567-.13L3.068 6.74a3.27 3.27 0 0 1-1.834-2.585l-.145-1.351c-.032-.296.06-.595.252-.822a.98.98 0 0 1 .696-.355c.448-.025.87.236 1.034.655l.683 1.746 7.354 3.691c.682.3.994 1.1.695 1.783a1.31 1.31 0 0 1-1.21.791M13 12.458a.54.54 0 0 0-.542-.542H.542a.542.542 0 1 0 0 1.084h11.916c.3 0 .542-.243.542-.542m-4-7.01L8.348 1.91A1.35 1.35 0 0 0 7.537.79l-.43-.184a.814.814 0 0 0-1.13.75V3.93l3.022 1.517"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h13v13H0z"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }